import { gql } from '@apollo/client'

export const TOGGLE_USER_MARKETING = gql`
  mutation ToggleUserMarketing($inputData: ToggleUserMarketingInput!) {
    toggleUserMarketing(inputData: $inputData)
  }
`
